var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseNavItem',{attrs:{"title":_vm.$t('quickDeal'),"icon":"$vuetify.icons.values.add","route":_vm.targetRoute,"visible":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }